import React, { useState, useEffect } from "react";
import Gallery from 'react-image-gallery'; // Import the gallery component
import 'react-image-gallery/styles/css/image-gallery.css';
import { NavLink, useParams } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
function BikeDetailVariants() {
    const [data, setData] = useState([]);
    const [imagesList, setImagesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/bike/products/detail/" + id;
            const result = await fetchData(url);
            if (result && result.data) {
                const images = result.data.media.map(item => ({
                    original: item.original_url,
                    thumbnail: item.original_url
                }));
                setImagesList(images)
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, [id]);
    const responsive = [
        {
            breakpoint: 1024, // Tablets and large mobile devices
            settings: {
                slidesToShow: 3,  // Display 3 images at a time on medium screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768, // Small devices (e.g. mobile phones)
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on mobile screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480, // Very small screens
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on very small screens
                slidesToScroll: 1,
            },
        },
    ];

    const rangeIcon = (size = "60px") => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#e4212b"/>
            <path d="M7.5 12.5l3 1.5 2.5-5.5 2.5 3.5 2-1" stroke="#e4212b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            <circle cx="7.5" cy="12.5" r="1.2" fill="#e4212b"/>
            <circle cx="17.5" cy="10.5" r="1.2" fill="#e4212b"/>
        </svg>
    );

    const batteryIcon = (size = "60px") => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="7" width="18" height="10" rx="2" stroke="#da232c" strokeWidth="2" fill="none"/>
            <rect x="4" y="9" width="12" height="6" rx="1" fill="#da232c"/>
            <path d="M20 10h2v4h-2" stroke="#da232c" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );

    const motorIcon = (size = "60px") => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" fill="#e5202b"/>
        </svg>
    );

    const speedIcon = (size = "60px") => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="#f2232d"/>
            <path d="M12 7v5l3.5 2.1-.9 1.5L10.5 13V7H12z" fill="#f2232d"/>
            <circle cx="12" cy="12" r="1.5" fill="#f2232d"/>
        </svg>
    );

    const getSpec = (source, key, fallbackKey) =>
        source?.bike_specification?.[key] ?? source?.[fallbackKey];

    return (
        <div className="container my-5">
            {loading && <MainLoader />}
            <div className="mt-4">
                {/* Modern Header */}
                <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                    <h1 className="display-4 fw-bold mb-2"><span className="brand-name">{data?.title}</span></h1>
                    <p className="lead">Find your perfect ride</p>
                </div>
            </div>
            <h3><span className="text-success">({data?.price_start} {data?.price_end === null ? '' : '- ' + data?.price_end})</span></h3>
            <div className="row mt-3 bg-light p-2">
                <div className="col-md-8 p-2">
                    <Gallery items={imagesList} autoPlay={false} responsive={responsive} />
                </div>

                <div className="col-md-4">
                    <div className="rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        {rangeIcon()}
                        <div className="ms-5">
                            <h6>Range (KM/Charge)</h6>
                            <p className="mb-0">{getSpec(data, 'range_per_charge', 'mileage')}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        {batteryIcon()}
                        <div className="ms-5">
                            <h6>Battery (V/Ah)</h6>
                            <p className="mb-0">{getSpec(data, 'battery_capacity', 'transmission')}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        {motorIcon()}
                        <div className="ms-5">
                            <h6>Motor (Watts)</h6>
                            <p className="mb-0">{getSpec(data, 'motor_power', 'fuel_type')}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex theme-light-bg align-items-center py-4 px-3">
                        {speedIcon()}
                        <div className="ms-5">
                            <h6>Top Speed (Km/h)</h6>
                            <p className="mb-0">{getSpec(data, 'top_speed', 'engine')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5">
                <h4>Bike Model Options & Variants</h4>
                <table className="table border mt-3">
                    <thead>
                        <tr className="">
                            <th scope="col" className="text-start">Variants</th>
                            <th scope="col" className="text-center">Price</th>

                        </tr>
                    </thead>
                    <tbody>
                        {data?.varient && data.varient.map((item, index) => (
                            <tr key={index}>
                                <td className="text-start p-3">
                                    <NavLink to={`${item.slug}`}>
                                        <h5 className="text-success">{item.title}</h5>
                                    </NavLink>
                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <div className="rounded d-flex  align-items-center p-2">
                                                {rangeIcon("35px")}
                                                <div className="ms-5">
                                                    <p className="x-small mb-0">Range (KM/Charge)</p>
                                                    <p className="mb-0 small">{getSpec(item, 'range_per_charge', 'mileage')}</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="rounded d-flex  align-items-center p-2">
                                                {batteryIcon("35px")}
                                                <div className="ms-5">
                                                    <p className="x-small mb-0">Battery (V/Ah)</p>
                                                    <p className="mb-0 small">{getSpec(item, 'battery_capacity', 'transmission')}</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="rounded d-flex  align-items-center p-2">
                                                {motorIcon("35px")}
                                                <div className="ms-5">
                                                    <p className="x-small mb-0">Motor (Watts)</p>
                                                    <p className="mb-0 small">{getSpec(item, 'motor_power', 'fuel_type')}</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="rounded d-flex  align-items-center p-2">
                                                {speedIcon("35px")}
                                                <div className="ms-5">
                                                    <p className="x-small mb-0">Top Speed (Km/h)</p>
                                                    <p className="mb-0 small">{getSpec(item, 'top_speed', 'engine')}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </td>
                                <td className="text-center text-success">{item.price_range}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default BikeDetailVariants;
